const english = {
    search_title: 'Search',
    search_everything: 'Find everything around Nara',
    search_accommodation: 'Find accommodations around Nara',
    search_activity: 'Find activity around Nara',
    search_product: 'Find product around Nara',
    search_restaurant: 'Find restaurants around Nara',
    search_subtitle: `Find activities around Nara`,
    search_subsubtitle: `Click <span class='emoji'>&#x2764</span>, and then proceed to booking from the Wishlist`,
    search_button: `Search`,
    search_price_range: 'Price Range',
    search_all_categories: 'All Categories',
    accommodation: 'Accommodation',
    activity: 'Activity',
    restaurant: 'Restaurant',
    produce: 'Produce',
    search_keyword: 'Type Keywords',
    wishlist_empty: 'Cart is Empty',
    close: 'Close',
    check_availability: 'Continue to Payment',
    load_more: 'Load More',
    loading: ' Loading ...',
    view_details: 'View',
    basic_info: 'Basic Information',
    map: 'Map',
    details: 'Details',
    home: 'Home',
    list: 'List',
    name: 'Name',
    address: 'Address',
    phone: 'Phone',
    website: 'Website',
    email: 'Email',
    fax: 'Fax',
    from: 'From',
    price: 'Price (tax incl.)',
    rate: 'Rate',
    under_maintenance: `Sorry, there are no products to display. 
    Please revisit this page again soon. <span class='emoji'>&#128521</span>`,
    add_to_wishlist: 'Book Now',
    add_to_wishlist_shp: 'Book Now',
    remove_from_wishlist: 'Remove Book',
    wishlist: 'Cart',
    not_available: 'Not Available',
    not_available_shp: 'Not Available',
    night: 'Night(s)',
    guest: 'Guest(s)',
    item: 'Item(s)',
    date: 'Date',
    read_more: 'read more',
    check_price_availability_res: 'Check Price & Availability',
    check_price_availability_acc: 'Check Price & Availability',
    check_price_availability_act: 'Check Price & Availability',
    check_price_availability_shp: 'Check Price & Availability',
    available_products: 'Available Products',
    available_products_act: 'Available Products',
    available_products_shp: 'Available Products',
    start_time: 'Start time',
    different_time: 'or choose a different time',
    dairy: 'Dairy',
    sweet: 'Sweet',
    wine: 'Wine',
    quantity: 'Quantity',
    request_to_book: 'Request to book',
    sort_by: 'Sort By',
    name_az: 'Name - Ascending',
    name_za: 'Name - Descending',
    price_az: 'Price - Ascending',
    price_za: 'Price - Descending',
    extras: 'Extras',
    no_public_website: 'No Public Website',
    no_public_email: 'No Public Email,',
    firstName: 'First Name',
    lastName: 'Last Name',
    userEmail: 'Email',
    conf_email: 'Re-Type Email',
    mobile: 'Mobile/Cell Phone',
    city: 'Suburb/City',
    state: 'State/Country',
    zipcode: 'Post Code/Zip',
    country: 'Country',
    marketing: 'Marketing',
    business: 'Business',
    specialRequest: 'Special Request Note',
    is_required: ' is required',
    is_not_the_same: ' is not the same',
    is_not_a_valid_email: ' is not valid',
    must_be_a_number: ' must be a number',
    select_country: 'Select Country',
    submit: 'Submit',
    customer_detail: 'Customer Detail',
    booking_information: 'Booking Information',
    product: 'Product',
    options_costs: 'Options/Costs',
    totals: 'Totals',
    adult: 'Adult(s)',
    check_in: 'Check In',
    check_out: 'Check Out',
    back_to_nara: 'Back To Nara',
    booking_req_detail_wait: 'Booking Request Details - awaiting confirmation',
    booking_req_instructions: "You'll receive an email within 24 hours to confirm if your booking request has been accepted by the operator. Payment is not due until your booking request has been accepted.",
    request_date: 'Request Date (UTC)',
    booking_reference: 'Booking Reference',
    booked_by: 'Booked by',
    supplier_information: 'Supplier Information',
    total_gst: 'Total (inc. GST)',
    amount_paid: 'Amount Paid (inc. GST)',
    amount_owing: 'Amount Owing (inc. GST)',
    quick_booking: 'Quick Booking',
    guest_warning: 'Minimum guest is 1'
};
export default english;
